import { render, staticRenderFns } from "./Argon.vue?vue&type=template&id=30a3164a&"
import script from "./Argon.vue?vue&type=script&lang=js&"
export * from "./Argon.vue?vue&type=script&lang=js&"
import style0 from "./Argon.vue?vue&type=style&index=0&id=30a3164a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports